// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import request from './request'

/**
 * @description 列表
 */
export function protectionListApi(data) {
  return request.get('protection/list', data)
}
export function protectionChartListApi() {
  return request.get('protection/chart/list')
}

export function protectionDetailApi(id) {
  return request.get(`protection/detail/${id}`)
}

export function protectionAuditApi(id,data) {
  return request.get(`protection/audit/${id}`, data)
}

export function protectionStatusDetailApi(id) {
  return request.get(`protection/status/list/${id}`)
}

export function saveProtectionStatusDataApi(data) {
  return request.post(`protection/status/save`, data)
}

export function protectionDeleteApi(id) {
  return request.delete(`protection/delete/${id}`)
}





